import { useAuth } from '@context/AuthContext';
import Fetch from '@helpers/Fetch';
import { useMemo } from 'react';

export default function useFetchApi(): Fetch {
  const { user } = useAuth();

  return useMemo(() => {
    if (!user) {
      throw new Error('Unable to create API fetcher. User not logged in.');
    }

    return new Fetch(() => user.getIdToken()); // .getIdToken() must be used inside an anonymous function
  }, [user]);
}
